// Company A: viewer (Stock ESM tab is only available here)
export const ESM_VIEWER_COMPANY_ID = 'vXxvVIjmbKt5XTusXbhD'

// Company B: source of packing lists, projects, work orders and PDFs
export const ESM_SOURCE_COMPANY_ID = 'F2QrwHnQQFxrcEMoLXE8'

// Client filter on company B projects
export const ESM_CLIENT_ID = '6cLxEvDWFxY5FXn2wuQW'

export function isStockESMViewerCompany(companyId) {
    return String(companyId) === ESM_VIEWER_COMPANY_ID
}
